import Base64 from "base-64";
function baseEncode(val) {
  // base64加密
  return Base64.encode(val);
}
export { baseEncode };
